export { default } from "./Tooltip.js";
